var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('x-empty',{attrs:{"message":"商品已下架，看看其他好物吧","confirm-text":"返回"},on:{"confirm":_vm.handleBackClick}})}
var staticRenderFns = []

export { render, staticRenderFns }